import React, {Component} from 'react';
import Pause from 'components/Pause';
import AudioPlayer from 'components/AudioPlayer';
import strings from 'strings';

import introAfterSe from '../../assets/sounds/se/intros/NonWord-Intro-AFTER-trail-exercises.mp3';

import ReadyButton from 'components/ReadyButton';

class PauseAfterTrial extends Component {
	constructor(props) {
		super(props);
		this.audio =  introAfterSe;
	}
	render() {
		return (
			<>
				<p>
					<AudioPlayer autoplay inline src={this.audio} />
					{strings.nonword_intro_after_trial_1}
				</p>
				<p>{strings.nonword_intro_after_trial_2}</p>
				<p>{strings.nonword_intro_after_trial_3}</p>
				<ReadyButton onReadyChange={this.props.setReady} />
			</>
		);
	}
}

export default PauseAfterTrial;
